import React, { useEffect, useState } from 'react';
import { getAdminActiveHosts } from '../../services/ledgerService';
import { BackButton } from '../../components/BackButton';
import TimeWindowFilter, { useTimeWindow } from './TimeWindowFilter';
import './GameDetails.css';

const ActiveHosts = () => {
    const { from, to } = useTimeWindow();
    const [hosts, setHosts] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        setHosts(null);
        setError(null);
        getAdminActiveHosts({ from, to })
            .then((body) => {
                if (cancelled) return;
                setHosts(body.hosts || []);
            })
            .catch((err) => {
                if (cancelled) return;
                console.error('Failed to load active hosts', err);
                setError(err.message || 'Failed to load active hosts');
            });
        return () => { cancelled = true; };
    }, [from, to]);

    return (
        <div className="game-details">
            <div className="detail-header">
                <BackButton to="/admin" />
                <h1>Active Hosts</h1>
            </div>
            <TimeWindowFilter />
            {error ? (
                <p className="text-danger">Error: {error}</p>
            ) : hosts === null ? (
                <p className="empty-state">Loading...</p>
            ) : hosts.length === 0 ? (
                <p className="empty-state">No hosts ran a game in this window.</p>
            ) : (
                <table>
                    <thead>
                        <tr>
                            <th>Owner Name</th>
                            <th>Owner Email</th>
                            <th>House</th>
                            <th>Games in Window</th>
                            <th>Last Game</th>
                        </tr>
                    </thead>
                    <tbody>
                        {hosts.map((host) => (
                            <tr key={host.ownerId}>
                                <td>{host.ownerName}</td>
                                <td>{host.ownerEmail}</td>
                                <td>{host.houseDescription}</td>
                                <td>{host.gamesInWindow}</td>
                                <td>{host.lastGameAt}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default ActiveHosts;
